import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=5c683d82&scoped=true&"
import script from "./Quiz.vue?vue&type=script&lang=js&"
export * from "./Quiz.vue?vue&type=script&lang=js&"
import style0 from "./quiz.css?vue&type=style&index=0&id=5c683d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c683d82",
  null
  
)

export default component.exports